import React from "react";
import PublicLayout from "../layouts/PublicLayout";
import useSEO from "../seo/use-seo";
import StandardPageHelmet from "../seo/components/StandardPageHelmet";

interface ComingSoonPageProps {
  pageName: string;
}

export default function ComingSoonPage({ pageName }: ComingSoonPageProps) {
  const seo = useSEO("login"); // Reuse some basic SEO or create a custom one

  return (
    <PublicLayout>
      <StandardPageHelmet seo={seo} />
      <div 
        style={{ 
          padding: "100px 20px", 
          textAlign: "center", 
          color: "white", 
          minHeight: "60vh", 
          display: "flex", 
          flexDirection: "column", 
          justifyContent: "center", 
          alignItems: "center" 
        }}
      >
        <h1 style={{ fontSize: "3rem", marginBottom: "20px", color: "#FE5A97" }}>
          {pageName}
        </h1>
        <p style={{ fontSize: "1.2rem", color: "rgba(255, 255, 255, 0.7)" }}>
          This page is currently under construction and will be available soon. Stay tuned!
        </p>
      </div>
    </PublicLayout>
  );
}
